/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Box, TextField } from '@mui/material';
import CustomDialog from '../../../../Components/Dialog/CustomDialog';

const SystemParametersDialog = function SystemParametersDialog({
  open,
  handleClose,
  onSubmit,
  settings,
  title,
  dialogId,
}) {
  const intl = useIntl();

  const [settingName, setSettingName] = useState(null);
  const [settingValue, setSettingValue] = useState(null);
  const [description, setDescription] = useState(null);
  const [editSetting, setEditSetting] = useState(false);

  useEffect(() => {
    if (open && dialogId === 'editSetting') {
      setSettingName(settings.settingName);
      setSettingValue(settings.settingValue);
      setDescription(settings.description);
      setEditSetting(true);
    }
  }, [open, dialogId]);

  const handleSettingNameChange = (e) => {
    setSettingName(e.target.value);
  };

  const handleSettingValueChange = (e) => {
    setSettingValue(e.target.value);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleSubmit = () => {
    onSubmit({
      settingName,
      settingValue,
      description,
    });
  };
  const reset = () => {
    setSettingName(null);
    setSettingValue(null);
    setDescription(null);
    setEditSetting(false);
  };

  return (
    <CustomDialog
      title={title}
      open={open}
      close={(_, reason) => {
        if (reason !== 'clickaway' && reason !== 'escapeKeyDown') {
          handleClose();
          reset();
        }
      }}
      disableEscapeKeyDown
      notRequiredFields
      messageDialog
      maxWidth="sm"
      fullWidth
      onSubmit={() => {
        handleSubmit();
        reset();
      }}
      submitDisabled={!(settingName && settingValue && description)}
      noBackdrop
      noForm
    >
      <Box
        sx={{
          display: "flex",
          width: "100%",
          flexDirection: "column",
          gap: "24px"
        }}>
        <Box
          sx={{
            display: "flex",
            gap: "16px",
            width: "100%"
          }}>
          {editSetting !== true && (
            <TextField
              id="settingName-txtField"
              onChange={handleSettingNameChange}
              label={intl.messages.NAME}
              required
              value={settingName}
              sx={{ width: '100%' }}
            />
          )}
          <TextField
            id="settingValue-txtField"
            onChange={handleSettingValueChange}
            label={intl.messages.VALUE}
            required
            value={settingValue}
            sx={{ width: '100%' }}
          />
        </Box>
        <TextField
          id="description-txtField"
          onChange={handleDescriptionChange}
          label={intl.messages.DESCRIPTION}
          multiline
          minRows={2}
          value={description}
        />
      </Box>
    </CustomDialog>
  );
};

SystemParametersDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.func.isRequired,
  dialogId: PropTypes.string.isRequired,
};

export default SystemParametersDialog;
